module.exports = __webpack_public_path__ + "static/media/Euro.871aed3e.svg";